export const defaultDragBoxValue = () => {
  return {
    styles: { width: 800, height: 400 },
    hollow_styles: { bg_color: "white", border_color: "#000", x: 0, y: 0 },
    square_styles: { width: 100, height: 100, bg_color: "skyblue", border_color: "#000" },
    num_columns: 0,
    num_rows: 0,
  };
};
